<gtd-ui-field-default-string-or-empty [data]="data"></gtd-ui-field-default-string-or-empty>
